export const Region = {
  // getting Region-data
  GET_REGION_DATA_BY_CITY: "GET_REGION_DATA_BY_CITY",
  GET_REGION_DATA_BY_CITY_SUCCESS: "GET_REGION_DATA_BY_CITY_SUCCESS",
  GET_REGION_DATA_BY_CITY_FAILURE: "GET_REGION_DATA_BY_CITY_FAILURE",

  // Clear RegionData
  CLEAR_REGION_DATA_BY_CITY: "CLEAR_REGION_DATA_BY_CITY",

  // Region Names actions
  GET_REGION_NAMES: "GET_REGION_NAMES",
  GET_REGION_NAMES_SUCCESS: "GET_REGION_NAMES_SUCCESS",
  GET_REGION_NAMES_FAILURE: "GET_REGION_NAMES_FAILURE",

  // TG Based Pincode Ranking
  GET_PINCODE_RANKING_BY_TG: "GET_PINCODE_RANKING_BY_TG",
  GET_PINCODE_RANKING_BY_TG_SUCCESS: "GET_PINCODE_RANKING_BY_TG_SUCCESS",
  GET_PINCODE_RANKING_BY_TG_FAILURE: "GET_PINCODE_RANKING_BY_TG_FAILURE",
  CLEAR_PINCODE_RANKING_BY_TG: "CLEAR_PINCODE_RANKING_BY_TG",
  SELECT_TG_ATTR_FOR_RANKING: "SELECT_TG_ATTR_FOR_RANKING",
  UNSELECT_TG_ATTR_FOR_RANKING: "UNSELECT_TG_ATTR_FOR_RANKING",
};
